import React from "react";

type LessonPageProps = {
  title?: string;
  children: React.ReactNode;
};

export default function LessonPage({ children }: LessonPageProps) {
  return (
    <div className="flex justify-center w-full px-4 pb-8 md:px-4">
      <div id="lesson" className="w-full max-w-[1040px]">
        {children}
      </div>
    </div>
  );
}
